let cef = {}
// 默认调用方法
cef.API = (method, data, success, error) => {
  if (!window.cefGameBox || !window.clientInfo) return
  if (method == 'clientOpenWnd') {
    let status = typeof data.status == 'undefined' ? 1 : data.status
    data.status = status
  }
  window.cefGameBox({
    request: JSON.stringify({
      method: method,
      data: data
    }),
    onSuccess: function(response) {
      success && success(JSON.parse(response))
    },
    onFailure: function(response) {
      error && error()
    }
  })
}

cef.Storage = {
  set(key, value, fn) {
    cef.API(
      'BoxStorageSetValue',
      {
        key: key,
        value: JSON.stringify(value)
      },
      fn
    )
  },
  get(key, fn) {
    cef.API(
      'BoxStorageGetValue',
      {
        key: key
      },
      fn
    )
  },
  del(key, fn) {
    switch (typeof key) {
      case 'string':
        cef.API(
          'BoxStorageDeleteValue',
          {
            key: key
          },
          fn
        )
        break
      case 'object':
        for (let i = 0; i < key.length; i++) {
          cef.API(
            'BoxStorageDeleteValue',
            {
              key: key[i]
            },
            fn
          )
        }
        break
    }
  }
}

export default cef
